import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Global flag to let programmatic section scrolling bypass ScrollToTop
let suppressNextScroll = false;
export function suppressScrollToTop() {
  suppressNextScroll = true;
}

export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (suppressNextScroll) {
      suppressNextScroll = false;
      return;
    }

    // If there's a hash (e.g. /#pricing), scroll to that element
    if (hash) {
      // Small delay to let the target page render first
      const timer = setTimeout(() => {
        const el = document.getElementById(hash.replace("#", ""));
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
      return () => clearTimeout(timer);
    }

    // No hash — scroll to top as usual
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}